// extracted by mini-css-extract-plugin
module.exports = {"button":"BecomePartnerForm_button__K3Rsu","long":"BecomePartnerForm_long__kqkVF"};